import React, { useState } from "react";
import { Button, makeStyles, Menu, MenuItem } from "@material-ui/core";
import OrderDetails from "./components/OrderDetails";
import { CircularProgress } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  root: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
    padding: 8,
    boxSizing: "border-box",
  },
  button: { marginRight: 10, borderRadius: 6, textTransform: 'none', color: '#E8EBED' }
}));

export const CatalogInetpretationContext = React.createContext(null);


const CatalogInterpretationSelect = () => {
  const cl = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [state, setState] = React.useState({
  order: null,
  comment: '',
  diagnos: '',
  fields: null,
  recomendation: '',
  result: null,
  l: false,
  e: null
 })

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };  
  
  return (<CatalogInetpretationContext.Provider value={[state, setState]}>
    <div className={cl.root}>
      {state.l 
      ? <CircularProgress size={24} /> 
      : <Button
        variant="outlined"
        color="inherite"
        className={cl.button}
        style={{ marginRight: 10, borderRadius: 12, textTransform: 'none', display: state?.order ? 'flex' : 'none' }}
        onClick={handleOpen}
      >
        <span style={{color: '#6FAA83'}}>
          Активний пацієнт</span>  <span style={{marginLeft: 6, fontWeight: 500, color: 'black'}}> {state?.order?.patient 
          && `${state?.order?.patient?.lastname || ''} ${state?.order?.patient?.firstname || ''} ${state?.order?.patient?.fathername || ''}`}</span>
      </Button>}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        keepMounted
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        style={{ padding: "8px" }}
      >
        <MenuItem disableGutters style={{ minWidth: "50vw",borderRadius: 12 }} disableRipple>
          <OrderDetails patient={true}/>
        </MenuItem>
      </Menu>
    </div>
  </CatalogInetpretationContext.Provider>);
};

export default CatalogInterpretationSelect;
